import { Link } from "react-router-dom";
import Logo from "./Logo";

export default function Footer() {
  return (
    <footer className="border-t border-white/10 bg-[#080808] mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 grid grid-cols-1 md:grid-cols-4 gap-8">
        <div className="md:col-span-2">
          <div className="-ml-2">
            <Logo />
          </div>
          <p className="text-white/60 text-sm mt-4 max-w-md">
            Officiell fotoplattform för enduroförare. Hitta dina bilder från Sveriges största enduroevent, stötta fotograferna och ge samtidigt tillbaka till förarna via sponsring.
          </p>
        </div>
        <div>
          <h4 className="label-overline mb-3">Plattform</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/search" className="text-white/70 hover:text-brand" data-testid="footer-search">Hitta foton</Link></li>
            <li><Link to="/sponsring" className="text-white/70 hover:text-brand" data-testid="footer-sponsorship">Sponsring</Link></li>
            <li><Link to="/photographer/register" className="text-white/70 hover:text-brand" data-testid="footer-register">Publicera dina foton</Link></li>
            <li><Link to="/admin/login" className="text-white/70 hover:text-brand" data-testid="footer-admin">Admin</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="label-overline mb-3">Kontakt</h4>
          <ul className="space-y-1 text-sm text-white/70">
            <li>
              <a href="mailto:info@enduroskola.se" className="text-white hover:text-brand" data-testid="footer-email">
                info@enduroskola.se
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/5 py-4 text-center text-xs text-white/40">
        © 2026 Enduroskola Foton · Alla bilder tillhör respektive fotograf
      </div>
    </footer>
  );
}
